import Client from "../client";
import OnboardingResource from "client/resources/onboardingResource";

class UserOnBoardingRepository {
    private client: Client;

    constructor(client: Client) {
        this.client = client;
    }

    get(): Promise<OnboardingResource> {
        return this.client.get(this.client.getRootDocument().Links["UserOnboarding"]);
    }
}

export default UserOnBoardingRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/userOnBoardingRepository.ts